export default "__VITE_PUBLIC_ASSET__85a7d04c__"